<template>
  <router-view />
</template>
<script>
  export default {
    name: 'TecnicoModule',
  }
</script>
